import { Checkbox, Grid, LinearProgress, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, CircularProgress } from '@material-ui/core';
import React, { useContext, useRef, useState, useEffect, memo } from 'react';
import { PrimaryButton, SecondaryButton, TextBox } from '../../../Core/FormInput';
import moment from 'moment';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import {
    Job_SearchByWIPAdmin,
    postDocumentsReprocessDeleteDocument,
    postDocumentsReprocessLinkToOtherJob
} from '../../../Core/Service/DocumentReprocess-service';
import AppContext from '../../../App/AppContext';

const StyledTableCell = withStyles(() => ({
    head: { fontSize: 12 },
    body: { fontSize: 12 }
}))(TableCell);

const StyledHeaderTableCell = withStyles(() => ({
    head: {
        fontSize: 12,
        border: '1px solid rgba(0,0,0,0.05)'
    },
    body: { fontSize: 12 }
}))(TableCell);

const StyledHeaderTableRow = withStyles(() => ({
    body: {
        fontSize: 12,
        border: '1px solid rgba(0,0,0,0.01)'
    }
}))(TableRow);

const useStyles = makeStyles(() => ({
    root: { width: '100%' },
    table: {
        border: '1px solid rgba(0,0,0,0.05)',
        '& .MuiTableCell-root': { padding: '0px 4px 0px 0px' }
    },
    tbody: { padding: '0px !important' }
}));

// Small presentational table component
const MatchingJobsTable = memo(({ jobs = [], loading = false, onJobSelect }) => {
    const classes = useStyles();
    return (
        <TableContainer style={{ width: '100%', overflowX: 'auto' }}>
            {loading && <LinearProgress />}
            <Table className={classes.table} stickyHeader>
                <TableHead>
                    <StyledHeaderTableRow hover>
                        <StyledHeaderTableCell width={'5%'}></StyledHeaderTableCell>
                        <StyledHeaderTableCell>WIP No</StyledHeaderTableCell>
                        <StyledHeaderTableCell>Reg No</StyledHeaderTableCell>
                        <StyledHeaderTableCell>Branch</StyledHeaderTableCell>
                        <StyledHeaderTableCell>Customer</StyledHeaderTableCell>
                        <StyledHeaderTableCell>Due In</StyledHeaderTableCell>
                    </StyledHeaderTableRow>
                </TableHead>

                <TableBody className={classes.tbody}>
                    {jobs.map((row, index) => (
                        <TableRow hover tabIndex={-1} key={index}>
                            <StyledTableCell>
                                <Checkbox
                                    checked={row.isSelected}
                                    color={row.isSelected ? 'primary' : 'default'}
                                    onChange={(e) => onJobSelect(e.target.checked, row.headerRecordID)}
                                />
                            </StyledTableCell>
                            <StyledTableCell>{row.wipNumber}</StyledTableCell>
                            <StyledTableCell>{row.registration}</StyledTableCell>
                            <StyledTableCell>{row.branch}</StyledTableCell>
                            <StyledTableCell>{row.customerName}</StyledTableCell>
                            <StyledTableCell>{row.dateDueIn ? moment(row.dateDueIn).format('DD/MM/yyyy') : ' - '}</StyledTableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
});

const DocumentsReprocessDocumentViewer = (props) => {
    const { showToast } = useContext(AppContext);

    const [state, setState] = useState({
        stockID: props.stockID,
        loading: false, // job search + attach
        documentLoading: false, // while iframe/img is loading
        selectedStockID: undefined,
        searchText: '',
        matchedJob: []
    });

    const timerRef = useRef(null);

    useEffect(() => {
        if (props.imageList) {
            setState((st) => ({ ...st, documentLoading: true }));
        } else {
            setState((st) => ({ ...st, documentLoading: false }));
        }
    }, [props.imageList, props.slectedFileExt]);

    useEffect(() => {
        return () => {
            if (timerRef.current) clearTimeout(timerRef.current);
        };
    }, []);

    const setSearchText = (e) => {
        const searchText = e.target.value;
        if (timerRef.current) clearTimeout(timerRef.current);
        setState((st) => ({ ...st, searchText, selectedHeaderId: undefined }));

        timerRef.current = setTimeout(async () => {
            if (searchText.length > 2) {
                setState((st) => ({ ...st, loading: true }));
                try {
                    const res = await Job_SearchByWIPAdmin(searchText);
                    if (res && res.success) {
                        setState((st) => ({
                            ...st,
                            matchedJob: res.data.map((j) => ({ ...j, isSelected: false }))
                        }));
                    } else {
                        showToast((res && res.message) || 'Search returned no results');
                    }
                } catch (err) {
                    setState((st) => ({ ...st, matchedJob: [], loading: false }));
                    console.error('Job search error', err);
                    showToast('Error searching jobs');
                } finally {
                    setState((st) => ({ ...st, loading: false }));
                }
            } else {
                setState((st) => ({ ...st, matchedJob: [], loading: false }));
            }
        }, 500);
    };

    const onJobSelect = (checked, jobHeaderId) => {
        setState((st) => {
            let newSt = { ...st };
            let job = newSt.matchedJob.find((d) => d.headerRecordID === jobHeaderId);
            if (job) {
                newSt.matchedJob.forEach((d) => (d.isSelected = false));
                job.isSelected = checked;
                newSt.selectedHeaderId = checked ? jobHeaderId : undefined;
                newSt.matchedJob = [...newSt.matchedJob];
            }
            return newSt;
        });
    };

    const onAttachSubmit = async () => {
        let data = {
            errorFolder: props.ErrorFolder,
            branchName: props.branchName,
            documentType: props.documentType,
            documentName: props.slectedFileName,
            headerRecordID: state.selectedHeaderId
        };

        try {
            setState((st) => ({ ...st, loading: true }));
            let res = await postDocumentsReprocessLinkToOtherJob(data);
            if (res && res.success) {
                showToast(res.data?.message || 'Attached successfully');
                props.onClose && props.onClose(true);
            } else {
                showToast((res && res.message) || 'Failed to attach document');
            }
        } catch (err) {
            console.error('Attach error', err);
            showToast('Error attaching document');
        } finally {
            setState((st) => ({ ...st, loading: false }));
        }
    };

    const onDeleteSubmit = async () => {
        setState((st) => ({ ...st, dltBtnLoader: true }));
        let res = await postDocumentsReprocessDeleteDocument(props.ErrorFolder, props.branchName, props.documentType, props.slectedFileName);
        if (res && res.success) {
            showToast(res.data?.message || 'Deleted successfully');
            props.onClose && props.onClose(true);
        } else {
            showToast((res && res.message) || 'Failed to delete document');
        }
        setState((st) => ({ ...st, dltBtnLoader: false }));
    };

    return (
        <Grid container spacing={2}>
            {/* LEFT PANEL */}
            <Grid item xs={12} md={4}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <SecondaryButton onClick={onDeleteSubmit} fullWidth isBtnLoader={state.dltBtnLoader}>
                            Delete Document
                        </SecondaryButton>
                    </Grid>

                    <Grid item xs={12}>
                        <Grid container spacing={1} alignItems="center">
                            <Grid item xs={12} sm={8}>
                                <TextBox label="Attach to WIP" onChange={setSearchText} value={state.searchText} autoFocus={true} fullWidth />
                            </Grid>

                            <Grid item xs={12} sm={4}>
                                <PrimaryButton onClick={() => onAttachSubmit(state.selectedHeaderId)} disabled={!state.selectedHeaderId} fullWidth>
                                    Attach
                                </PrimaryButton>
                            </Grid>
                        </Grid>

                        <div style={{ overflowX: 'auto', maxHeight: '60vh', marginTop: 8 }}>
                            <MatchingJobsTable jobs={state.matchedJob} loading={state.loading} onJobSelect={onJobSelect} />
                        </div>
                    </Grid>
                </Grid>
            </Grid>

            {/* RIGHT PANEL */}
            <Grid item xs={12} md={8} style={{ height: '90vh' }}>
                <div style={{ height: '100%', position: 'relative' }}>
                    {state.documentLoading && (
                        <div
                            style={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                background: 'rgba(255,255,255,0.6)',
                                zIndex: 10
                            }}
                        >
                            <CircularProgress />
                        </div>
                    )}

                    {props.slectedFileExt === '.pdf' ? (
                        <iframe
                            src={props.imageList}
                            id="editviewer"
                            frameBorder="0"
                            scrolling="auto"
                            allowFullScreen
                            width="100%"
                            height="100%"
                            style={{ borderRadius: 6 }}
                            onLoad={() => setState((st) => ({ ...st, documentLoading: false }))}
                        />
                    ) : (
                        <img
                            src={props.imageList}
                            alt="No document selected"
                            style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'contain',
                                borderRadius: 6
                            }}
                            onLoad={() => setState((st) => ({ ...st, documentLoading: false }))}
                        />
                    )}
                </div>
            </Grid>
        </Grid>
    );
};

export default DocumentsReprocessDocumentViewer;
